<script setup lang="ts">
import { useField } from 'vee-validate'
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps<{
  name?: string
  label: string
  type?: string
  placeholder?: string
  modelValue?: string | number
  errorText?: string
}>()

const emit = defineEmits(['update:modelValue'])

// Usar useField para integrar com vee-validate
const { value: inputValue, errorMessage } = useField<string | number>(props.name, undefined, {
  initialValue: props.modelValue,
})

// Proxy para manter compatibilidade com v-model
const proxyValue = computed({
  get: () => inputValue.value,
  set: (value) => {
    inputValue.value = value
    emit('update:modelValue', value)
  },
})
</script>

<template>
  <div class="mb-4">
    <label class="mb-2.5 block font-medium text-black dark:text-white">
      {{ props.label }}
    </label>
    <div class="relative min-w-75">
      <input
        v-model="proxyValue"
        :type="props.type"
        :placeholder="props.placeholder"
        class="w-full border border-zinc-300 bg-white py-4 pl-6 pr-10 text-black outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary" />
      <span class="absolute right-4 top-4">
        <slot />
      </span>
    </div>
    <p v-if="errorMessage || props.errorText" class="mt-1 text-sm italic text-red">
      {{ errorMessage || props.errorText }}
    </p>
  </div>
</template>
